import { Box, Typography } from "@mui/material";
import { translate } from "../../../../../translate/translate";

const LEGEND_ITEMS = [
    { color: "#22C55E", label: "concluido_label" },
    { color: "#3B82F6", label: "status_running_legend" },
    { color: "#F87171", label: "status_delayed_legend" },
    { color: "#F59E0B", label: "delayed_for_3_days" },
    { color: "#CBD5E1", label: "nao_iniciada_label" },
];

const NpiDashboardLegendComponent = () => (
    <Box sx={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: 2, width: "auto" }} id={"dashboard-legenda"}>
        {LEGEND_ITEMS.map((item) => (
            <Box key={item.label} sx={{ display: "flex", alignItems: "center", gap: 0.75, width: "auto", flexShrink: 0 }}>
                <Box sx={{ width: 10, height: 10, flexShrink: 0, borderRadius: "50%", backgroundColor: item.color }} />
                <Typography sx={{ fontSize: "12px", fontWeight: 400, color: "#64748B", whiteSpace: "nowrap" }}>{translate.t(item.label)}</Typography>
            </Box>
        ))}
    </Box>
);

export default NpiDashboardLegendComponent;
